import BaseAPI from "./BaseAPI";
import { stockOperationRoute } from "../routes";

export default class StockOperationAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, stockOperationRoute, "stock-operation");
    }

    async Apply(data, key) {
        const result = await this._request("post", this._url("/apply"), data, {
            headers: { "Idempotency-Key": key }
        });
        this._emit("create", result.id);
        return result;
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async ListByIntakeID(intakeID) {
        return this._request("get", this._url(`?intake_id=${intakeID}`));
    }
}
